export default __webpack_public_path__ + "c944ac81210ee40e76ca8af5b99ef5b9.svg";